import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BoBarchartComponent } from 'src/app/components/controls/bo-barchart/bo-barchart.component';
import { BoDonutchartComponent } from 'src/app/components/controls/bo-donutchart/bo-donutchart.component';
import { BoGaugechartComponent } from 'src/app/components/controls/bo-gaugechart/bo-gaugechart.component';
import { BoLinechartComponent } from 'src/app/components/controls/bo-linechart/bo-linechart.component';
import { BoPiechartComponent } from 'src/app/components/controls/bo-piechart/bo-piechart.component';
import { BoStackedbarchartComponent } from 'src/app/components/controls/bo-stackedbarchart/bo-stackedbarchart.component';
import { CommonService } from 'src/app/services/common-service/common.service';

@Component({
  selector: 'app-chart-controls',
  templateUrl: './chart-controls.component.html',
  styleUrls: ['./chart-controls.component.scss'],
  imports :[ReactiveFormsModule,FormsModule,BoStackedbarchartComponent,CommonModule,
    BoGaugechartComponent,BoBarchartComponent,BoLinechartComponent,BoDonutchartComponent,BoPiechartComponent
  ]
})
export class ChartControlsComponent implements OnInit {
  @Input() chartForm!: FormGroup;
  constructor(private formBuilder: FormBuilder,public commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.ogLog('chartForm:', this.chartForm);
  }

}
